import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00100-conditions-form" }
const _hoisted_2 = { class: "row q-gutter-x-sm" }
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  class: "col q-gutter-x-xs flex justify-end",
  style: {"margin-top":"10px"}
}
const _hoisted_8 = { class: "cmd00100-result-table" }
const _hoisted_9 = { class: "full-width row q-gutter-sm" }
const _hoisted_10 = { class: "q-pt-xs" }
const _hoisted_11 = { class: "add-btn-area flex items-center filter-select" }
const _hoisted_12 = {
  class: "flex",
  style: {"justify-content":"flex-start"}
}

import Loading from 'quasar/src/plugins/Loading.js';;
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';

import ResultStatusCode from '../../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';

interface MSupplier {
  supplier_code: string;
  supplier_name: string;
  priority: number;
  real_supplier_code: string;
  real_supplier_name: string;
  maker_code: string;
  del_flg: string;
  create_timestamp: Date;
  update_timestamp: Date;
  create_user_name: string;
  update_user_name: string;
}

// カラム表示機能
interface VisibleColumn {
  name: string;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00100',
  setup(__props) {

const router = useRouter();

// 検索条件：サプライヤコード
const supplierCode = ref('');
// 検索条件：サプライヤ名
const supplierName = ref('');
// 検索条件：無効データを含む
const isAllSearch = ref(false);
// 表示カラム
const visibleColumns = ref<Array<string>>([]);
// カラム表示設定の選択肢
const visibleColumnOptions = ref<Array<VisibleColumn>>([]);
// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

// カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: Array<any> = [
  {
    name: 'edit',
    field: (row: MSupplier) => row.supplier_code,
    required: true,
  },
  {
    name: 'supplier_code',
    label: 'サプライヤコード',
    align: 'left',
    field: (row: MSupplier) => row.supplier_code,
    sortable: true,
    style: 'width: 130px',
  },
  {
    name: 'supplier_name',
    label: 'サプライヤ名',
    align: 'left',
    field: (row: MSupplier) => row.supplier_name,
    sortable: true,
  },
  {
    name: 'priority',
    label: '優先順位',
    align: 'left',
    field: (row: MSupplier) => row.priority,
    classes: 'text-right',
    sortable: true,
    style: 'width: 80px',
  },
  {
    name: 'vendor_code',
    label: '仕入先コード',
    align: 'left',
    field: (row: MSupplier) => row.real_supplier_code,
    sortable: true,
    style: 'width: 110px',
  },
  {
    name: 'vendor_name',
    label: '仕入先名',
    align: 'left',
    field: (row: MSupplier) => row.real_supplier_name,
    sortable: true,
  },
  {
    name: 'maker_code',
    label: 'メーカーコード',
    align: 'left',
    field: (row: MSupplier) => row.maker_code,
    sortable: true,
    style: 'width: 120px',
  },
  {
    name: 'register',
    label: '登録者',
    align: 'left',
    field: (row: MSupplier) => row.create_user_name,
    sortable: true,
  },
  {
    name: 'regist_date',
    label: '登録日時',
    align: 'left',
    field: (row: MSupplier) => row.create_timestamp,
    sortable: true,
    style: 'width: 170px',
  },
  {
    name: 'updater',
    label: '更新者',
    align: 'left',
    field: (row: MSupplier) => row.update_user_name,
    sortable: true,
  },
  {
    name: 'update_date',
    label: '更新日時',
    align: 'left',
    field: (row: MSupplier) => row.update_timestamp,
    sortable: true,
    style: 'width: 170px',
  },
];

// 表示データ
const rows = ref<MSupplier[]>([]);

/**
 * サプライヤ新規登録に遷移
 */
const registerData = () => {
  router.push({ name: 'supplierRegist', params: { mode: '0' } });
};

/**
 * サプライヤ情報変更に遷移
 * @param {string} supplierCd サプライヤコード
 */
const editData = (supplierCd: string) => {
  router.push({ name: 'supplierEdit', params: { mode: '1', supplierCd } });
};

/**
 * サプライヤ検索
 */
const searchSupplier = async () => {
  // Loading Start
  Loading.show();
  // 検索条件設定
  const formData = new FormData();
  formData.append('supplier_code', supplierCode.value);
  formData.append('supplier_name', supplierName.value);
  formData.append('is_all_search', isAllSearch.value.toString());

  // サプライヤ検索
  await axios
    .post('/cmd001001/search', formData)
    .then((res) => {
      const { common, supplierList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          rows.value = supplierList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          // エラーメッセージ表示
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

/**
 * 検索条件クリア
 */
const clearSearchCondition = () => {
  supplierCode.value = '';
  supplierName.value = '';
  isAllSearch.value = false;
};

/**
 * 初期表示処理
 */
// カラム表示設定
for (let i = 0; i < columns.length; i += 1) {
  visibleColumns.value.push(columns[i].name);
  // 編集ボタンのカラムは除外
  if (columns[i].name !== 'edit') {
    visibleColumnOptions.value.push({
      name: columns[i].name,
      label: columns[i].label,
    });
  }
}
// サプライヤ検索
searchSupplier();

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("サプライヤ一覧")
      ])),
      _: 1
    }),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      onSubmit: searchSupplier,
      onReset: clearSearchCondition
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_card, {
            style: {"background":"var(--q-lightGray)"},
            flat: "",
            bordered: "",
            class: "q-mb-lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "q-gutter-y-sm" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", null, "サプライヤコード", -1)),
                      _createVNode(_component_q_input, {
                        modelValue: supplierCode.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((supplierCode).value = $event)),
                        outlined: "",
                        dense: "",
                        style: {"background":"var(--q-white)"},
                        class: "input-area",
                        maxlength: "4",
                        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", null, "サプライヤ名", -1)),
                      _createVNode(_component_q_input, {
                        modelValue: supplierName.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((supplierName).value = $event)),
                        outlined: "",
                        dense: "",
                        style: {"background":"var(--q-white)"},
                        class: "input-area",
                        maxlength: "200",
                        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_q_checkbox, {
                        modelValue: isAllSearch.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isAllSearch).value = $event)),
                        label: "無効データを含む"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_q_btn, {
                        type: "submit",
                        color: "primary",
                        style: {"width":"150px"},
                        label: "検索",
                        icon: "mdi-magnify"
                      }),
                      _createVNode(_component_q_btn, {
                        type: "reset",
                        outline: "",
                        style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                        icon: "mdi-eraser",
                        label: "クリア"
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist table-top-button ' + (rows.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-supplier-table",
          rows: rows.value,
          columns: columns,
          "row-key": "index",
          flat: "",
          dense: "",
          "visible-columns": visibleColumns.value,
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "rows-per-page": "20",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_10, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_q_select, {
                modelValue: visibleColumns.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((visibleColumns).value = $event)),
                multiple: "",
                outlined: "",
                dense: "",
                "options-dense": "",
                "display-value": "カラム表示設定",
                "emit-value": "",
                "map-options": "",
                options: visibleColumnOptions.value,
                "option-value": "name",
                color: "primary",
                class: "column-disp"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_q_btn, {
                icon: "mdi-plus",
                label: "追加",
                class: "add-btn",
                color: "primary",
                onClick: registerData
              })
            ])
          ]),
          "header-cell-edit": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area" })
          ]),
          "body-cell-edit": _withCtx((cell) => [
            _createVNode(_component_q_td, {
              class: _normalizeClass('table-btn-area ' + (cell.row.del_flg === '1' ? 'deleted' : ''))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_q_btn, {
                    icon: "mdi-pencil",
                    label: "編集",
                    color: "primary",
                    onClick: ($event: any) => (editData(cell.row.supplier_code))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          "body-cell": _withCtx((cell) => [
            _createVNode(_component_q_td, {
              props: cell,
              class: _normalizeClass(cell.row.del_flg === '1' ? 'deleted' : '')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cell.value), 1)
              ]),
              _: 2
            }, 1032, ["props", "class"])
          ]),
          _: 1
        }, 8, ["rows", "visible-columns", "hide-no-data", "pagination-label"])
      ], 2)
    ])
  ]))
}
}

})